import script from "./CallsEmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./CallsEmptyState.vue?vue&type=script&setup=true&lang=js"

import "./CallsEmptyState.vue?vue&type=style&index=0&id=7aa77f32&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa77f32"]])

export default __exports__